import { Card } from "@/components/card";

import { QuestionItems } from "./QuestionItems";
import { UsageTitle } from "./UsageTitle";

const HistoricalDialogList = () => (
  <Card className="pb-4">
    <div className="flex h-full flex-col gap-5">
      <UsageTitle />
      <QuestionItems />
    </div>
  </Card>
);

export default HistoricalDialogList;
